module.exports = __webpack_public_path__ + "img/cen_w.22bd5810.svg";